import { AttendantTaskProgressType } from '@ac/library-api';

export const AttendantTaskOrder: AttendantTaskProgressType[] = [
  AttendantTaskProgressType.InProgress,
  AttendantTaskProgressType.Paused,
  AttendantTaskProgressType.Pending,
  AttendantTaskProgressType.Skipped,
  AttendantTaskProgressType.Completed
];



// WEBPACK FOOTER //
// ./src/components/Attendant/shared/config/attendantTaskOrder.ts